import { Lista } from "../types/lista";

export const novaLista = (): Lista => {
  return {
    codigo: "",
    descricao: "",
    itens: [],
  };
};
